module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/line-4@3x.png?1.0.17";